import React from "react";


/**
 * A description for a setting item.
 */
export function SettingItemDesc({ children, className }: SettingItemDescProps) {
    return (
        <p className={`text-[11px] font-mono leading-relaxed ${className ?? ''}`}
            style={{ color: 'var(--sc-muted)' }}>
            {children}
        </p>
    );
}

type SettingItemDescProps = {
    children: React.ReactNode;
    className?: string;
}


/**
 * A setting item.
 */
export function SettingItem({
    label,
    htmlFor,
    required,
    showOptional,
    showNew,
    showIf,
    children
}: SettingItemProps) {
    if (showIf === false) return null;
    return (
        <div className="grid grid-cols-1 md:grid-cols-[220px_1fr] gap-3 md:gap-6 items-start py-4 border-b last:border-0"
            style={{ borderColor: 'var(--sc-border)' }}>
            <div className="flex flex-col gap-1 pt-1">
                <label htmlFor={htmlFor} className="text-[11px] font-bold tracking-wide"
                    style={{ color: 'var(--sc-text)' }}>
                    {label}
                    {required && <span className="ml-1 text-[9px] font-mono px-1.5 py-0.5 rounded" style={{ background: 'rgba(0,255,209,0.1)', color: 'var(--sc-cyan)' }}>required</span>}
                    {showOptional && <span className="ml-1 text-[9px] font-mono" style={{ color: 'var(--sc-muted)' }}>optional</span>}
                    {showNew && <span className="ml-1 text-[9px] font-mono px-1.5 py-0.5 rounded" style={{ background: 'rgba(167,139,250,0.15)', color: 'var(--sc-purple)' }}>new</span>}
                </label>
            </div>
            <div className="flex flex-col gap-2">{children}</div>
        </div>
    );
}

type SettingItemProps = {
    label: string;
    htmlFor?: string;
    required?: boolean;
    showOptional?: boolean;
    showNew?: boolean;
    showIf?: boolean;
    children: React.ReactNode;
}


/**
 * A divider for advanced options.
 */
export function AdvancedDivider() {
    return (
        <div className="flex items-center gap-3 py-2">
            <div className="flex-1 h-px" style={{ background: 'var(--sc-border)' }} />
            <span className="text-[9px] font-mono font-bold uppercase tracking-[0.2em]"
                style={{ color: 'rgba(0,255,209,0.4)' }}>
                Advanced Settings
            </span>
            <div className="flex-1 h-px" style={{ background: 'var(--sc-border)' }} />
        </div>
    );
}
